<template>
    <div class="row">
        <div class="card">
            <div class="card-header">
                <h2>Gerar Boleto</h2>
            </div>
            <form-incluir-boleto />
        </div>
    </div>
</template>

<script>
import FormIncluirBoleto from './form-incluir-boleto'
export default {
        components: {
            FormIncluirBoleto
        }
}
</script>